var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-action"},[_vm._t("content",function(){return [_c('flex-layout',[_c('flex-column',[_vm._t("left")],2),_c('flex-column',{staticClass:"right"},[_vm._t("default")],2)],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }